function handleSubscriptionChange(event) {
  const subscriptionRadio = event.target;
  const subscriptionWidgetContainer = document.querySelector('.subscription_widget__container');
  const sellingPlanSelect = subscriptionWidgetContainer.querySelector('#subscriptionPlan');
  const sellingPlanInput = document.getElementById('selling_plan');

  if (subscriptionRadio.checked) {
    sellingPlanInput.value = sellingPlanSelect.value;
  }
}

function handleSellingPlanChange(event) {
  const sellingPlanSelect = event.target;
  const subscriptionRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
  const sellingPlanInput = document.getElementById('selling_plan');

  if (subscriptionRadio.checked) {
    sellingPlanInput.value = sellingPlanSelect.value;
  }
}

function handleOneTimeChange(event) {
  const oneTimeRadio = event.target;
  const sellingPlanInput = document.getElementById('selling_plan');

  if (oneTimeRadio.checked) {
    sellingPlanInput.value = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const subscriptionRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
    const oneTimeRadio = document.querySelector('input[name="purchaseOption"][value="one_time"]');
    const sellingPlanSelect = document.querySelector('#subscriptionPlan');
    const sellingPlanInput = document.getElementById('selling_plan');

  
    if (subscriptionRadio && subscriptionRadio.checked) {
      sellingPlanInput.value = sellingPlanSelect.value;
    } else if (oneTimeRadio && oneTimeRadio.checked) {
      sellingPlanInput.value = '';
    }
  }, 500);
});
